import { useRef } from 'react';
import { useQuery } from '@zg-rentals/react-query5';
import { useSelector } from 'react-redux';

type QueryOptions = {
  onSuccess?: (response: unknown) => void;
  onError?: (err: unknown) => void;
  enabled?: boolean;
};

type ReturnProps = {
  buildNumber: number;
  growthApi: string;
  name: string;
  zgApi: string;
};

const useBuildNumber = (queryOptions: QueryOptions = {}) => {
  const {
    // @ts-expect-error
    app: {
      appConfig: {
        config: {
          features: { maxBuildIncrementLimit },
        },
      },
    },
  } = useSelector((state) => state);

  const prevRef = useRef({
    initialRender: true,
    buildNumber: 0,
  });

  const queryFn = (): Promise<ReturnProps> =>
    fetch('rental-manager/check').then((res) => res.json() as Promise<ReturnProps>);

  const queryHook = useQuery({
    queryKey: ['useBuildNumber'],
    queryFn: async () => {
      try {
        const data = await queryFn();
        queryOptions.onSuccess?.(data);

        if (!prevRef.current.initialRender && prevRef.current.buildNumber + maxBuildIncrementLimit < data.buildNumber) {
          window.location.reload();
          return;
        }

        prevRef.current.initialRender = false;
        prevRef.current.buildNumber = data.buildNumber;

        return data;
      } catch (err) {
        queryOptions.onError?.(err);
        throw err;
      }
    },
    ...queryOptions,
    refetchOnWindowFocus: true,
    staleTime: 60 * 60 * 1000, // 1 hr
    retry: 1,
  });

  return queryHook;
};

export { useBuildNumber };
